<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center"><small>Professional Wallet</small> | {{ professional.name }}</h3>
        </v-flex>
        <v-flex xs12 sm11 md9>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn small title="Payout" @click="goTo(`/professionals/${professional.id}/wallets/create`)">Debit / Credit</v-btn>
            </v-card-title>
            <v-card-text>
              <wallet-entries :entries="wallets" :credits="credits" :debits="debits"></wallet-entries>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const WalletEntries = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "wallets" */ '@/Components/Wallets/entries')

  export default {
    name: 'ProfessionalWallet',
    layout,
    props: [
      'professional',
      'balance',
      'credits',
      'debits'
    ],
    components: {
      WalletEntries,
    },
    metaInfo () {
      return {
        title: 'Professional Wallet | ' + this.professional.name,
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {}
    },
    methods: {
      somemethod () {},
    },
    created () {
      // this.somemethod()
    },
    computed: {
      wallets () {
        return this.professional.wallets
      }
    },
    watch: {
      '$route': 'somemethod',
    }
  }
</script>

<style>
   /**/
</style>
